module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white min-height"
  }, [_c('home-sidebar', {
    attrs: {
      "active_item": "charge"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "bg-white ml-3 min-height"
  }, [_c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "content-box pt-2 pb-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("账户充值\n              ")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticStyle: {
      "background-color": "#409EFF"
    },
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "white",
      "margin-bottom": "0px"
    }
  }, [_vm._v("当前账户余额：" + _vm._s(_vm.balance.remain) + " 个金币")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-link', {
    staticClass: "ml-3",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._v("给他人转账")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-box pt-2 pb-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("充值金额\n              ")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h1', {
    staticClass: "p-3",
    staticStyle: {
      "margin-bottom": "0px",
      "color": "#666"
    },
    on: {
      "click": function($event) {
        _vm.form.totalAmount = 100
      }
    }
  }, [_vm._v("100元")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h1', {
    staticClass: "p-3",
    staticStyle: {
      "margin-bottom": "0px",
      "color": "#666"
    },
    on: {
      "click": function($event) {
        _vm.form.totalAmount = 200
      }
    }
  }, [_vm._v("200元")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h1', {
    staticClass: "p-3",
    staticStyle: {
      "margin-bottom": "0px",
      "color": "#666"
    },
    on: {
      "click": function($event) {
        _vm.form.totalAmount = 500
      }
    }
  }, [_vm._v("500元")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h1', {
    staticClass: "p-3",
    staticStyle: {
      "margin-bottom": "0px",
      "color": "#666"
    },
    on: {
      "click": function($event) {
        _vm.form.totalAmount = 1000
      }
    }
  }, [_vm._v("1000元")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-box pt-2 pb-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("充值说明\n              ")])]), _vm._v(" "), _c('div', [_c('div', [_vm._v("1. 充值后的金额可用于DATAWILL平台上的所有付费功能，方便您随时使用，无需每次都单独付费；")]), _vm._v(" "), _c('div', [_vm._v("2. 充值后系统将默认使用账户余额支付；")]), _vm._v(" "), _c('div', [_vm._v("3. 余额不足时，可选择组合付款，灵活应对各种需求；")]), _vm._v(" "), _c('div', [_vm._v("4. 充值后不支持退款，请您按需充值。")]), _vm._v(" "), _c('div', {
    staticClass: "pt-2 pb-2"
  }, [_c('el-checkbox'), _vm._v("\n                我已阅读并同意《充值服务协议》\n              ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pt-3"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitPayment
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    staticClass: "pl-3"
  }, [_vm._v("确认支付:" + _vm._s(_vm.form.totalAmount))])], 1)], 1)])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be3baa1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/Charge.vue
// module id = 290
// module chunks = 1